import React from 'react';
import PropTypes from 'prop-types';
import urlIcon from 'affiliateIcons/url.svg';

const WorkspaceTableText = ({ title, label, withLink }) => (
  <div className="workspace-table-text">
    {withLink && (
      <div className="workspace-table-text__link">
        <span className="workspace-table-text__link-text">{withLink}</span>
        <span className="workspace-table-text__icon-wrapper">
          <a
            href={withLink}
            target="_blank"
            rel="noopener noreferrer"
            className="workspace-table-text__icon"
          >
            <img src={urlIcon} alt="url-icon" />
          </a>
        </span>
      </div>
    )}
    {title && <div className="workspace-table-text__title">{title}</div>}
    <div className="workspace-table-text__label">{label}</div>
  </div>
);

WorkspaceTableText.defaultProps = {
  withLink: '',
  title: '',
};

WorkspaceTableText.propTypes = {
  title: PropTypes.string,
  label: PropTypes.node.isRequired,
  withLink: PropTypes.string,
};

export default WorkspaceTableText;
